import Barba from 'barba.js';
import { styler, keyframes, easing } from 'popmotion';
import store from 'store';
// import * as config from 'config';


export default Barba.BaseView.extend({

    namespace: 'home',

    /**
     * The new Container is ready and attached to the DOM.
     */
    onEnter() {
        store.commit('setIsOnHome', true);

        // if (!config.SITE_IS_BLACK) this.invertColors(['#FFFFFF', '#000000'], Barba.Pjax.History.prevStatus() === null ? 0 : 400);
    },


    /**
     * A new Transition toward a new page has just started.
     */
    onLeave() {
        store.commit('setIsOnHome', false);

        // if (!config.SITE_IS_BLACK) this.invertColors(['#000000', '#FFFFFF']);

        const canvasElement = document.querySelector('.threeCanvas');
        canvasElement.classList.add('animate-out');
        document.body.classList.remove('no-overflow');
    },


    invertColors(colors, duration = 400) {

        const body = document.getElementsByTagName('BODY')[0];
        // const headerNavLinks = Array.from(document.querySelectorAll('.main-header .js-animateLink'));
        const lionPaths = Array.from(document.querySelectorAll('.svgHeaderLion .svgHeaderLion-filledPath'));
        const wappenPaths = Array.from(document.querySelectorAll('.svgHeaderWappen .svgHeaderWappen-filledPath'));
        const isMobile = window.matchMedia('(max-width: 740px)');

        // Change background color
        keyframes({
            values: colors,
            duration,
            ease: easing.linear,
        }).start({
            update: styler(body).set('backgroundColor'),
        });

        // change font color
        keyframes({
            values: colors.reverse(),
            duration: (isMobile.matches) ? duration : 0,
            ease: easing.linear,
        }).start({
            update: (color) => {
                // headerNavLinks.forEach(item => styler(item).set({ color }));
                lionPaths.forEach(item => styler(item).set({ fill: color }));
                wappenPaths.forEach(item => styler(item).set({ fill: color }));
            },
        });
    },

});

